import { ca } from '@cian/analytics';

type TPlaceType = 'main_button' | 'gallery';

export const trackBookingButtonClick = (gaLabel: string, placeType: TPlaceType) => {
  const extra: Record<TPlaceType, boolean> = {
    main_button: false,
    gallery: false,
  };

  extra[placeType] = true;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Booking_popup_open_floating_block',
    category: 'Card',
    label: gaLabel,
    useLastProducts: true,
    page: {
      extra,
    },
  });
};
